// extracted by mini-css-extract-plugin
export default {"wrap":"FF-z","fullWidth":"GF-z","hideOnDesktop":"HF-z","content":"IF-z","hasOpenedNav":"JF-z","crumbsList":"KF-z","dropdownsWrap":"LF-z"};